
























































































































































































































































import { defineComponent, reactive, SetupContext, ref, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import TeacherMainteTab from "../../components/TeacherMainteTab.vue"
import { User } from "../../modules/teacher/TeacherList"
import { BModal } from 'bootstrap-vue';


interface Data {
  currentUser: any
  users: User[]
  errors: string[]
  condition: {
    role: string,
    curriculum_id: string,
    name: string,
  };
  isAllCheckedPassword: boolean
  isAllCheckedDelete: boolean
  isAllCheckedResetLoginFailedCount: boolean
  fields: any[]
  tabNo: number
  editTargetUser: User
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "teacher-mainte-tab": TeacherMainteTab,
  },
  setup(props, context: SetupContext) {

    const modalUserEditRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      currentUser: context.root.$store.state.currentUser,
      users: [],
      errors: [],
      condition: {
        role: "",
        curriculum_id: "",
        name: ""
      },
      isAllCheckedPassword: false,
      isAllCheckedDelete: false,
      isAllCheckedResetLoginFailedCount: false,
      fields: [
        {key: "role", label: "権限", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "80px"}},  
        {key: "login_id", label: "Email", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "birthday", label: "生年月日", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "curriculums", label: "担当教科", class: 'text-center b-table-th-td', thStyle: {width: "260px"}},
        {key: "login_count", label: "ログイン回数", class: 'text-center b-table-th-td', thStyle: {width: "70px"}},
        {key: "login_failed_count", label: "ログイン制限", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "last_login_at", label: "前回ログイン", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "edit", label: "編集", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "reset_password", label: "パスワード再設定", class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
        {key: "delete", label: "削除", class: 'text-center b-table-th-td', thStyle: {width: "70px"}},
      ],
      tabNo: 1,
      editTargetUser: null,
    });

    if(context.root.$store.getters.isOptionSchoolSubjectActive){
      // 学校別科目マスタオプションONの場合は担当科目列を表示
      state.fields.splice(5, 0, {key: "school_subjects", label: "担当科目", class: 'text-center b-table-th-td', thStyle: {width: "400px"}});
    }


    /******************************
     * methods
     ******************************/

    const clearCondition = (): void => {
      state.condition.role = "";
      state.condition.curriculum_id = "";
      state.condition.name = "";
    }

    /**
     * ユーザ一覧検索処理
     */
    const searchUsers = async (): Promise<void> => {
      
      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/teacher/teacher_list?${Common.BuildQuery(state.condition, 'search_user')}`).then(response => {

        // 検索結果設定
        state.users = response.data.users.map((x: any) => new User(x, context.root.$store.state.curriculums, context.root.$store.state.schoolSubjects));
        state.users.forEach(x => x.jsonUserCache = JSON.stringify(x));

        /* ** 初期化 ** */
        state.isAllCheckedPassword = false;
        state.isAllCheckedDelete = false;
        state.isAllCheckedResetLoginFailedCount = false;
      })
      .catch(error => {

        if (error.response.status == 422) {
          state.errors = error.response.data.errors;
        } else {
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * ログイン制限解除
     */
    const resetLoginFailedCount = async (): Promise<void> => {

      const ids = state.users.filter(x => x.is_login_failed_checked).map(x => x.id);
      if (ids.length == 0) {
        alert(`ログイン制限を解除する教師が選択されていません。`);
        return;
      }

      if (!confirm(`ログイン制限を解除します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/reset_login_failed_count`, {ids: ids}).then(response => {
        alert(`処理が完了しました。`);
        searchUsers();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }


    /**
     * パスワード再設定、メール送信処理
     */
    const resetPassword = async (): Promise<void> => {

      const ids = state.users.filter(x => x.is_password_checked).map(x => x.id);
      if (ids.length == 0) {
        alert(`パスワードをリセットする教師が選択されていません。`);
        return;
      }

      if (!confirm(`本当にパスワード再設定を行ってもよろしいですか？再設定を行うと現在のパスワードが更新されます。`)) {
        return;
      }
      
      if (ids.includes(context.root.$store.state.currentUser.id)) {
        if (!confirm(`ログイン者もパスワードリセットの対象ですが、よろしいでしょうか？`)) {
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/send_reset_mail`, {ids: ids}).then(response => {
        alert(`選択した教師のメールアドレスに新しいパスワードを送信しました。`);
        searchUsers();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /**
     * ユーザ削除処理
     */
    const deleteUser = async (): Promise<void> => {

      const ids = state.users.filter(x => x.is_delete_checked).map(x => x.id);

      if (ids.length == 0) {
        alert(`削除する教師をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      if (ids.includes(context.root.$store.state.currentUser.id)) {
        if (!confirm(`ログイン者も削除対象ですが、削除してもよろしいでしょうか？`)) {
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/delete_users`, {ids: ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 教科保存処理
     */
    const updateCurriculum = async (): Promise<void> => {

      if (!confirm(`担当教科を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/update_curriculum`, {users: state.users}).then(response => {
        alert(`担当教科の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 科目保存処理
     */
    const updateSubject = async (): Promise<void> => {

      if (!confirm(`担当科目を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      // 担当科目を変更している教師に絞り込んでパラメータ設定
      const targetUsers: any[] = [];
      state.users.forEach(user => {
        const codes = user.school_subjects.filter(x => x.is_selected).map(x => x.subject_code);
        if(codes.length !== user.subject_codes.length || [...codes].sort().join(",") !== [...user.subject_codes].sort().join(",")){
          targetUsers.push({id: user.id, subject_codes: codes});
        }
      });

      await http.post(`/api/teacher/teacher_list/update_subject`, {users: targetUsers}).then(response => {
        alert(`担当科目の更新が完了しました。`);
        searchUsers();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /**
     * 有効/無効状態保存処理
     */
    const updateUserActive = async (): Promise<void> => {

      if (!confirm(`有効/無効状態を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/update_active`, {users: state.users}).then(response => {
        alert(`有効/無効状態の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    const getConvertDate = (date: Date, format: string): string => {
      if (!date) {
        return "-";
      }

      return Common.formatDate(date, format);
    }

    const to = (path: string, query: {[key: string]: string}): void => {

      if (query == null) {
        context.root.$router.push({path: path}).catch(err => {});
      } else {
        context.root.$router.push({path: path, query: query}).catch(err => {});
      }
    }

    // ユーザー編集モーダル表示
    const showUserEditModal = (user: User) => {
      state.editTargetUser = JSON.parse(user.jsonUserCache) as User;
      modalUserEditRef.value.show();
    }

    // ユーザー情報更新
    const updateUser = async () => {
      if (!confirm(`教師情報をを更新します。よろしいですか？`)) {
        return;
      }

      modalUserEditRef.value.hide();

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/update_user`, {user: state.editTargetUser}).then(response => {
        alert(`教師情報の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }


    /******************************
     * created
     ******************************/
    
    searchUsers();

    /******************************
     * watch
     ******************************/

    watch(() => state.isAllCheckedPassword, (newVal) => {
      state.users.forEach(x => x.is_password_checked = newVal);
    });

    watch(() => state.isAllCheckedDelete, (newVal) => {
      state.users.forEach(x => x.is_delete_checked = newVal);
    });

    watch(() => state.isAllCheckedResetLoginFailedCount, (newVal) => {
      state.users.filter(x => x.login_failed_count >= 5).forEach(x => x.is_login_failed_checked = newVal);
    });

    return {
      ...toRefs(state),
      modalUserEditRef,
      clearCondition,
      searchUsers,
      resetPassword,
      deleteUser,
      updateCurriculum,
      updateSubject,
      updateUserActive,
      getConvertDate,
      to,
      resetLoginFailedCount,
      showUserEditModal,
      updateUser,
    };
  },
})
